import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Button, Form, Header, TextArea } from 'semantic-ui-react';

import _get from 'lodash/get';
import { useDispatch } from 'react-redux';

import { flagBusinessSaved } from 'actions/business';

import './ProfileInformationForm.scss';

const propTypes = {
  currentProviderData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    overrides: PropTypes.shape({}),
    snapshot: PropTypes.shape({}),
  }),
  updateProviderData: PropTypes.func.isRequired,
};

const defaultProps = {
  currentProviderData: null,
};

export default function ProfileInformation({ currentProviderData, updateProviderData }) {
  const dispatch = useDispatch();

  const [profileDescription, setProfileDescription] = useState('');
  const [hasProfileDescriptionChanged, setHasProfileDescriptionChanged] = useState(false);
  const [savingDescription, setSavingDescription] = useState(false);

  // Update profile description when provider data changes
  useEffect(() => {
    if (currentProviderData) {
      const description =
        _get(currentProviderData, 'overrides.profile.description', '') ||
        _get(currentProviderData, 'snapshot.profile.description', '');
      setProfileDescription(description);
      setHasProfileDescriptionChanged(false);
    } else {
      setProfileDescription('');
      setHasProfileDescriptionChanged(false);
    }
  }, [currentProviderData]);

  function handleProfileDescriptionChange(event) {
    setProfileDescription(event.target.value);
    setHasProfileDescriptionChanged(true);
  }

  async function saveProfileDescription() {
    if (currentProviderData && hasProfileDescriptionChanged) {
      setSavingDescription(true);
      try {
        const overrides = {
          ..._get(currentProviderData, 'overrides', {}),
          profile: {
            ..._get(currentProviderData, 'overrides.profile', {}),
            description: profileDescription,
          },
        };

        await updateProviderData(currentProviderData.id, overrides);
        setHasProfileDescriptionChanged(false);
        dispatch(flagBusinessSaved(true));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error saving profile description:', error);
      } finally {
        setSavingDescription(false);
      }
    }
  }

  return (
    <div className="profile-information">
      <Header as="h3" className="section-header">
        Profile
      </Header>
      <Form>
        <Form.Field>
          <label htmlFor="business-description">Business Description</label>
          <TextArea
            id="business-description"
            placeholder="Enter a description for your business..."
            value={profileDescription}
            onChange={handleProfileDescriptionChange}
            fluid
          />
          <div className="save-button-container">
            <Button
              primary
              onClick={saveProfileDescription}
              loading={savingDescription}
              disabled={!hasProfileDescriptionChanged || savingDescription}
            >
              Save
            </Button>
          </div>
        </Form.Field>
      </Form>
    </div>
  );
}

ProfileInformation.propTypes = propTypes;
ProfileInformation.defaultProps = defaultProps;
